<template>
    <div style="width: 1220px; margin: 0px auto">
        <div style="padding-top: 20px;display: flex">
            <left-menu></left-menu>
            <div class="usercontainer">
               <div class="userheader">
                   修改密码
               </div>
                <el-form  :rules="classFormCheck"  :model="userinfo" ref="userinfo" style="padding: 20px 130px 20px 0px">
                    <el-form-item label="新密码" prop="password" label-width="140px">
                        <el-input
                                v-model="userinfo.password"
                                type="password"
                                autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="确认新密码" prop="checkPass" label-width="140px">
                        <el-input
                                v-model="userinfo.checkPass"
                                type="password"
                                autocomplete="off"
                        ></el-input>
                    </el-form-item>

                </el-form>
                <div class="formfooter">
                    <el-button type="primary" @click="changeInfo" size="large">
                        保存
                    </el-button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import userInfo from "../../api/userInfo";
    import leftMenu from "../../components/LeftMenu";

    export default {
        name: "Password",
        components:{
            leftMenu
        },
        data() {
            let validatePass2 = (rule, value, callback) => {
                    if (value === undefined || value=='') {
                        callback(new Error('请输入新密码'))
                    } else if (value !== this.userinfo.password) {
                        callback(new Error("两次输入密码不一致，请重新输入"))
                    } else {
                        callback()
                    }
            }
            return {

                userinfo: {


                },
                user:{

                },
                classFormCheck: {
                    password:[
                        {
                            required: true,
                            message: "请输入新密码",
                            trigger: "blur",
                        },
                    ],
                    checkPass: [
                        { validator: validatePass2, trigger: 'blur' ,required: true,}
                    ],
                },
            }
        },
        created() {

        },
        methods: {

            changeInfo(){
                this.$refs.userinfo.validate((valid) => {
                    if (valid) {
                        this.user.password=this.userinfo.password
                        userInfo.changeUserinfo(this.user).then(res => {
                            if (res.data.code === 200) {
                             this.$alert(res.data.detail, "", {
                                    confirmButtonText: "确定",

                                });
                            }else{
                                this.$alert(res.data.detail, "", {
                                    confirmButtonText: "确定",

                                });
                            }


                        });

                    } else {

                        return false;
                    }
                });
            },

        }
    }
</script>

<style scoped>

</style>